<script lang="ts">
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { t, locale } from "$lib/i18n";
  import { formatDate, formatDateDisplay } from "$lib/utils/utils";
  import { X } from "@lucide/svelte";

  let {
    date = $bindable<Date | null>(null),
    expiryDate = $bindable<Date | null>(null),
    isReadonly = false,
    invalid = false,
  }: { date: Date | null; expiryDate?: Date | null; isReadonly?: boolean; invalid?: boolean } = $props();

  let dateString = $derived(formatDate(date!));
  $effect(() => {
    if (dateString === '') {
      date = null;
      return;
    }
    date = new Date(dateString);
  });

  let expiryDateString = $derived(formatDate(expiryDate!));
  $effect(() => {
    if (expiryDateString === '') {
      expiryDate = null;
      return;
    }
    expiryDate = new Date(expiryDateString);
  });

  let showExpiryDate = $derived(!isReadonly || expiryDate !== null);
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label for="issue_date" class="text-right">{$t('fields.issueDate')}</Label>
  {#if showExpiryDate}
    {#if isReadonly}
      <span id="issue_date">{formatDateDisplay(date!, $locale)}</span>
    {:else}
      <Input
        id="issue_date"
        type="date"
        bind:value={dateString}
        aria-invalid={invalid ? "true" : undefined}
      />
{/if}
    <div class="col-span-2 flex items-center gap-2">
      <Label for="expiry_date" class="shrink-0">{$t('fields.expiryDate')}</Label>
      <div class="relative flex-1">
        {#if isReadonly}
          <span id="expiry_date">{formatDateDisplay(expiryDate!, $locale)}</span>
        {:else}
          <Input
            id="expiry_date"
            type="date"
            bind:value={expiryDateString}
            class="w-full"
          />
          {#if expiryDate !== null}
            <button
              type="button"
              title={$t('fields.clearExpiryDate')}
              onclick={() => { expiryDate = null; }}
              class="absolute right-2 top-1/2 -translate-y-1/2 opacity-50 hover:opacity-100 focus:outline-none"
            ><X size={14} /></button>
          {/if}
        {/if}
      </div>
    </div>
  {:else}
    {#if isReadonly}
      <span id="issue_date" class="col-span-3">{formatDateDisplay(date!, $locale)}</span>
    {:else}
      <Input
        id="issue_date"
        type="date"
        bind:value={dateString}
        aria-invalid={invalid ? "true" : undefined}
        class="col-span-3"
      />
    {/if}
  {/if}
</div>
